import * as $ajax from './_ajax'
import * as $msg from './_msg'
import * as $helpers from './_helpers'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    flagId: number
    message: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $('.' + options.pagePrefix + '-btn-delete').click(function () {
        $('.' + options.pageName)
            .parent()
            .load('/Flag/ListSharesForFlag?flagId=' + options.flagId + '&delete=' + $(this).attr('data-id'))
    })

    $('.' + options.pagePrefix + '-btn-canedit').click(function () {
        $('.' + options.pageName)
            .parent()
            .load('/Flag/ListSharesForFlag?flagId=' + options.flagId + '&edit=' + $(this).attr('data-id'))
    })

    $('.' + options.pagePrefix + '-new-share-save').click(function () {
        $('.' + options.pageName)
            .parent()
            .load('/Flag/ListSharesForFlag?flagId=' + options.flagId + '&email=' + $('.' + options.pagePrefix + '-new-share').val())
    })

    $helpers.onEnter($('.' + options.pagePrefix + '-new-share'), function () {
        $('.' + options.pagePrefix + '-new-share-save').trigger('click')
    })

    if (options.message && options.message.length > 0) {
        $msg.showError(options.message)
    }
}
